import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import styles from './ep-pricing-esm-components-volume-discount-volume-discount.module.scss.js';
import { clsx } from './ep-pricing-esm-external-clsx-dist-clsx.js';
import { Typography, ErrorBoundary } from '@vp/swan';
import { useLocalization } from './ep-pricing-esm-hooks-useLocalizations.js';
import useDiscountCalculator from './ep-pricing-esm-hooks-useDiscountCalculator.js';

const VolumeDiscountInternal = forwardRef((props, ref) => {
  const { className, unitDiscountedPrice, vatInc, unitPriceForMoq, totalListPrice, totalDiscountedPrice, locale, ...rest } = props;
  const { t } = useLocalization(locale);
  const classNames = clsx(className, styles.volumeDiscount);
  const { discountedPercentage, isDiscounted } = useDiscountCalculator({
    unitPriceForMoq,
    unitDiscountedPrice,
    totalListPrice,
    totalDiscountedPrice,
    vatInc
  });
  if (discountedPercentage <= 0) return null;
  return /* @__PURE__ */ jsx(Typography, { as: "span", ref, className: classNames, fontSkin: "body-small-bold", textColor: "promo", ...rest, children: t(isDiscounted ? "volumeDiscountPlusSale" : "volumeDiscount", { volumeDiscount: discountedPercentage.toFixed(0) }) });
});
forwardRef((props, ref) => {
  const { className, placeholdertext } = props;
  return /* @__PURE__ */ jsx(
    ErrorBoundary,
    {
      fallback: /* @__PURE__ */ jsx(Typography, { as: "span", className: clsx(className, styles.volumeDiscount), fontSkin: "body-small-bold", textColor: "promo", children: placeholdertext }),
      children: /* @__PURE__ */ jsx(VolumeDiscountInternal, { ...props, ref })
    }
  );
});

export { VolumeDiscountInternal };
//# sourceMappingURL=ep-pricing-esm-components-volume-discount-volume-discount.component.js.map
